const e = {
  extends: "Cash4Life",
  logo: !0,
  style: {
    colorPrimary: "#2b8069"
  }
};
export {
  e as default
};
